import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=1fb8a7ea&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports